import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Index from '@/components/page/Index'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Blast from '@/components/page/Blast'

import SpeciesBlast from '@/components/page/SpeciesBlast'
import BlastCenter from '@/components/page/BlastCenter'
import UserManage from '@/components/page/UserManage'
import Services from '@/components/page/Services'

import Primer from '@/components/page/Primer'
import Download from '@/components/page/Download'
import Detail from '@/components/page/Detail'
import Species from '@/components/page/Species'
import Search from '@/components/page/Search'
import Family from '@/components/page/Family'
import Genus from '@/components/page/Genus'

import Contactus from '@/components/page/server/Contactus'
import VipServer from '@/components/page/server/VipServer'
import ClusterAnalysis from '@/components/page/server/Cluster_analysis'
import EvolutionaryAnalysis from '@/components/page/server/Evolutionary_analysis'
import ContractionAndExpansionAnalysis from '@/components/page/server/Contraction_and_expansion_analysis'
import WholeGeneReplicationAnalysis from '@/components/page/server/Whole_gene_replication_analysis'
import CircosDraw from '@/components/page/server/Circos_draw'
import SelectionPressureAnalysis from '@/components/page/server/Selection_pressure_analysis'
import CollinearityAnalysis from '@/components/page/server/Collinearity_analysis'
import MetabolicPathwayAnalysis from '@/components/page/server/Metabolic_pathway_analysis'
import GeneClusterAnalysis from '@/components/page/server/Gene_cluster_analysis'
import Wgcna from '@/components/page/server/Wgcna'
import Gene_data_download from '@/components/page/server/Gene_data_download'
import Vip from '@/components/page/server/vip'
import UpdatePwd from '@/components/UpdatePwd'
import personalCenter from '@/components/page/personalCenter'

import News from '@/components/news/news'
import News2 from '@/components/news/news2'
import News3 from '@/components/news/news3'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/updatepwd',
      name: 'UpdatePwd',
      component: UpdatePwd
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '/',
          name: 'Main',
          component: Index
        },
        {
          path: '/personalCenter',
          name: 'PersonalCenter',
          component: personalCenter
        },
        {
          path: '/news',
          name: 'News',
          component: News
        },
        {
          path: '/news2',
          name: 'News2',
          component: News2
        },
        {
          path: '/news3',
          name: 'News3',
          component: News3
        },
        {
          path: '/vip',
          name: 'Vip',
          component: Vip
        },
        {
          path: '/wgcna',
          name: 'Wgcna',
          component: Wgcna
        },
        {
          path: '/gene_data_download',
          name: 'Gene_data_download',
          component: Gene_data_download
        },
        {
          path: '/gene_cluster_analysis',
          name: 'GeneClusterAnalysis',
          component: GeneClusterAnalysis
        },
        {
          path: '/contactus',
          name: 'Contactus',
          component: Contactus
        },
        {
          path: '/vipServer',
          name: 'VipServer',
          component: VipServer
        },
        {
          path: '/metabolic_pathway_analysis',
          name: 'MetabolicPathwayAnalysis',
          component: MetabolicPathwayAnalysis
        },
        {
          path: '/collinearity_analysis',
          name: 'CollinearityAnalysis',
          component: CollinearityAnalysis
        },
        {
          path: '/selection_pressure_analysis',
          name: 'SelectionPressureAnalysis',
          component: SelectionPressureAnalysis
        },
        {
          path: '/circos_draw',
          name: 'CircosDraw',
          component: CircosDraw
        },
        {
          path: '/whole_gene_replication_analysis',
          name: 'WholeGeneReplicationAnalysis',
          component: WholeGeneReplicationAnalysis
        },
        {
          path: '/contraction_and_expansion_analysis',
          name: 'ContractionAndExpansionAnalysis',
          component: ContractionAndExpansionAnalysis
        },
        {
          path: '/evolutionary_analysis',
          name: 'EvolutionaryAnalysis',
          component: EvolutionaryAnalysis
        },
        {
          path: '/cluster_analysis',
          name: 'ClusterAnalysis',
          component: ClusterAnalysis
        },
        {
          path: '/services',
          name: 'Services',
          component: Services
        },
        {
          path: '/blast',
          name: 'Blast',
          component: Blast
        },
        {
          path: '/speciesblast',
          name: 'SpeciesBlast',
          component: SpeciesBlast
        },
        {
          path: '/blastcenter',
          name: 'BlastCenter',
          component: BlastCenter
        },
        {
          path: 'usermanage',
          name: 'UserManage',
          component: UserManage
        },
        {
          path: 'species',
          name: 'Species',
          component: Species
        },
        {
          path: 'search',
          name: 'Search',
          component: Search
        },
        {
          path: 'primer',
          name: 'Primer',
          component: Primer
        },
        {
          path: 'download',
          name: 'Download',
          component: Download
        },
        {
          path: 'detail',
          name: 'Detail',
          component: Detail
        },
        {
          path: 'family',
          name: 'Family',
          component: Family
        },
        {
          path: 'genus',
          name: 'Genus',
          component: Genus
        },
      ]
    },

  ]
})

export default router;

